<template>
  <v-container fluid class="container-view">
    <v-card>
      <v-card-title class="pb-5 font-futura">
        <div class="pb-2 site-map-title">Plan du site</div>
        <v-divider></v-divider>
      </v-card-title>
      <v-card-text>
        <div
          v-if="isLogged"
          class="pb-5 font-futura-subtitle"
        >
          <a
            href="https://www.onesyk.fr/contact"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Contact
          </a>
        </div>

        <div
          v-if="isLogged"
          class="pb-5 font-futura-subtitle"
        >
          <a
            href="https://www.onesyk.fr/service-one-stryker"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Services et avantages
          </a>
        </div>

        <div
          v-if="isLogged"
          class="pb-5 font-futura-subtitle"
        >
          <a
            href="https://www.onesyk.fr/contrat"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Contrats
          </a>
        </div>

        <div
          v-if="isLogged"
          class="pb-5 font-futura-subtitle"
        >
          <a
            href="https://www.onesyk.fr/stryker-commands"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Commandes Stryker
          </a>
        </div>

        <div
          v-if="isLogged"
          class="pb-5 font-futura-subtitle"
        >
          <a
            href="https://www.onesyk.fr/stryker-one-commands"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Commandes Programme One
          </a>
        </div>

        <div
          v-if="isLogged"
          class="pb-5 font-futura-subtitle"
        >
          <a
            href="https://www.onesyk.fr/points"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Utilisation des points
          </a>
        </div>
        <!-- https://www.onesyk.fr/cart -->

        <div class="pb-5 font-futura-subtitle">
          <a
            href="https://www.onesyk.fr/privacy"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Déclaration de confidentialité
          </a>
        </div>

        <div class="pb-5 font-futura-subtitle">
          <a
            href="https://www.onesyk.fr/accessibility"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Accessibilité au site Web
          </a>
        </div>

        <div class="pb-5 font-futura-subtitle">
          <a
            href="https://www.onesyk.fr/disclaimer"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Informations à l'intention des professionnels de santé
          </a>
        </div>

        <div class="pb-5 font-futura-subtitle">
          <a
            href="https://www.onesyk.fr/terms-of-use"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Conditions Générales d'Utilisation
          </a>
        </div>

        <div class="pb-5 font-futura-subtitle">
          <a
            href="https://www.onesyk.fr/sitemap"
            target="_blank"
            color="#577d7a"
            class="text-decoration-none site-map-link"
          >
            Plan du site
          </a>
        </div>
        <div class="font-futura-button">
          <div>Dernières mises à jour février/2025</div>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

export default {
  name: "SiteMapView",
  data() {
    return {
      // data
    };
  },
  methods: {},
  computed: {
    isLogged() {
      return !(
        this.$store.state.auth.user == null ||
        this.$store.state.auth.token == null
      );
    },
  },
  mounted() {
    // mounted
  },
};
</script>

<style>
.site-map-title {
  color: #ffb500;
}

.site-map-link {
  color: #577d7a; /* couleur par défaut */
  text-decoration: none; /* pour supprimer le soulignement si nécessaire */
}

.site-map-link:visited {
  color: #577d7a; /* couleur après avoir été visité */
}

.site-map-link:hover {
  color: #385c5a; /* couleur quand la souris passe dessus */
}

.site-map-link:active {
  color: #385c5a; /* couleur quand on clique dessus */
}
</style>
